var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md:flex md:items-end"},[_c('CardImage',{staticClass:"mb-8 md:mb-0 md:mr-8",attrs:{"card":_vm.card}}),_c('PointsBar',{staticClass:"md:flex-1",attrs:{"card":_vm.card},on:{"refresh":_vm.refresh}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }